import React from 'react';
import { Badge } from '@wix/design-system';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import s from './FreeDomainBadge.module.scss';
export const FreeDomainBadge = _ref => {
  let {
    size = 'tiny'
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const badgeKey = 'domains_search_suite.anon_storefront_results.optimizations.initial_vs_renewal.voucher_badge';
  return /*#__PURE__*/React.createElement(Badge, {
    skin: "neutralSuccess",
    size: size,
    uppercase: false,
    prefixIcon: /*#__PURE__*/React.createElement(Gift, {
      width: 18,
      height: 18
    }),
    className: s.badge
  }, t(badgeKey));
};
//# sourceMappingURL=FreeDomainBadge.js.map